import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import { loadCognitoFormsAdmin } from '../../../../../state/modules/cognitoFormsAdmin/actions';
import CognitoFormsAdminList from '../components/CognitoFormsAdminList';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.cognitoFormsAdmin.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['cognitoFormsAdmin', x]),
                schema.cognitoFormAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              code: x.registration_code?.code ?? '',
              code_alias: x.registration_code?.code_alias ?? '',
              form_id: x?.form_id ?? '',
              form_key: x?.form_key ?? '',
              name: x?.name ?? '',
              profile_name: x.profile
                ? x.profile.first_name + ' ' + x.profile.last_name
                : '',
              ...x,
            };
          })
      : [],
    isLoading: state.cognitoFormsAdmin.get('isLoading'),
    total: state.cognitoFormsAdmin.get('total'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadCognitoFormsAdmin(partnershipId, page, limit, order, filter, cb)
      );
    },
  };
};

const CognitoFormsAdminListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsAdminList);

export default CognitoFormsAdminListContainer;
